import React from "react";
import { api, fmtDateTime } from "../../lib/api";
import { PriorityBadge } from "../common";
import { Clock, Trash2, Copy } from "lucide-react";

export default function Scheduled({ items, onChanged }) {
  async function cancel(m) {
    await api.delete(`/messages/${m.id}`);
    onChanged?.();
  }
  async function duplicate(m) {
    const future = new Date(Date.now() + 15 * 60000).toISOString();
    await api.post(`/channels/${m.channel_id}/messages`, {
      content: m.content, sender_type: m.sender_type, sender_identity_id: m.sender_identity_id,
      priority: m.priority, scheduled_at: future,
    });
    onChanged?.();
  }

  return (
    <div className="flex-1 overflow-y-auto p-5" style={{ background: "var(--r-void)" }}>
      <div className="max-w-3xl mx-auto">
        <div className="sys-label mb-1 flex items-center gap-2"><Clock size={12} /> TIMELINE</div>
        <h2 className="font-title font-bold text-xl tracking-tight mb-5">MESSAGES PROGRAMMÉS</h2>
        <div className="relative pl-5 border-l border-[color:var(--r-primary)]/25 space-y-4">
          {items.map((m) => (
            <div key={m.id} data-testid={`scheduled-item-${m.id}`} className="relative frame p-3">
              <span className="absolute -left-[26px] top-4 w-2.5 h-2.5 rounded-full" style={{ background: "var(--r-primary)", boxShadow: "0 0 8px var(--r-primary)" }} />
              <div className="flex items-center justify-between mb-1">
                <span className="ts" style={{ color: "var(--r-primary)" }}>{fmtDateTime(m.scheduled_at)}</span>
                <div className="flex items-center gap-2">
                  {m.priority !== "NORMAL" && <PriorityBadge level={m.priority} />}
                  <button onClick={() => duplicate(m)} className="text-[color:var(--r-text-muted)] hover:text-[color:var(--r-primary)]" title="Dupliquer"><Copy size={13} /></button>
                  <button data-testid={`cancel-scheduled-${m.id}`} onClick={() => cancel(m)} className="text-[color:var(--r-text-muted)] hover:text-[color:var(--r-alert)]" title="Annuler"><Trash2 size={13} /></button>
                </div>
              </div>
              <div className="sys-label mb-1">{m.channel_name}</div>
              <div className="text-sm whitespace-pre-wrap">{m.content}</div>
            </div>
          ))}
          {items.length === 0 && <div className="sys-label">AUCUN MESSAGE PROGRAMMÉ</div>}
        </div>
      </div>
    </div>
  );
}
